import { Injectable } from '@angular/core';
import { FuelDispatch } from './api.service';

@Injectable({ providedIn: 'root' })
export class DnPrintService {
    private fmtDate(d?: string): string {
        if (!d) return '';
        const dt = new Date(d);
        return isNaN(dt.getTime()) ? '' : dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    private v(x: any): string {
        return x === null || x === undefined || x === '' ? '' : String(x);
    }

    private slipHtml(r: FuelDispatch, logoUrl: string, companyName: string): string {
        const rd = [r.tank1RD, r.tank2RD, r.tank3RD, r.tank4RD, r.tank5RD];
        const pd = [r.tank1PD, r.tank2PD, r.tank3PD, r.tank4PD, r.tank5PD];
        const qd = [r.tank1QD, r.tank2QD, r.tank3QD, r.tank4QD, r.tank5QD];

        let opRows = '';
        for (let i = 0; i < 5; i++) {
            opRows += `
                <tr>
                    <td class="c">${i + 1}</td>
                    <td></td>
                    <td class="c">${i === 0 ? this.v(r.product) : ''}</td>
                    <td class="c">${this.v(rd[i])}</td>
                    <td class="c">${this.v(pd[i])}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="c">${this.v(qd[i])}</td>
                </tr>`;
        }

        const logoCell = logoUrl ? `<img class="logo-img" src="${logoUrl}" />` : `<div class="logo-space"></div>`;

        return `
        <div class="dn-slip">
            <div class="head">
                <div class="head-logo">${logoCell}</div>
                <div class="head-title">
                    <div class="company">${companyName || ''}</div>
                    <div class="subtitle">Delivery Advice Note</div>
                </div>
                <div class="head-spacer"></div>
            </div>

            <table class="info">
                <tr>
                    <td class="lbl">From (Location)</td><td class="cl">:</td><td class="val">${this.v(r.fromLocation)}</td>
                    <td class="lbl">To (Location)</td><td class="cl">:</td><td class="val">${this.v(r.toLocation)}</td>
                </tr>
                <tr>
                    <td class="lbl">Date</td><td class="cl">:</td><td class="val">${this.fmtDate(r.documentDate)}</td>
                    <td class="lbl">DN Number</td><td class="cl">:</td><td class="val">${this.v(r.dnNumber)}</td>
                </tr>
                <tr>
                    <td class="lbl">Tank Lorry No.</td><td class="cl">:</td><td class="val">${this.v(r.tlNumber)}</td>
                    <td class="lbl">Indent Number</td><td class="cl">:</td><td class="val">${this.v(r.indentNumber)}</td>
                </tr>
                <tr>
                    <td class="lbl">Quantity</td><td class="cl">:</td><td class="val">${this.v(r.quantity)}</td>
                    <td class="lbl">Calibration No.</td><td class="cl">:</td><td class="val"></td>
                </tr>
                <tr>
                    <td class="lbl">Carriage Cont.</td><td class="cl">:</td><td class="val">${this.v(r.carriageContractor)}</td>
                    <td class="lbl">Calibration Expiry</td><td class="cl">:</td><td class="val"></td>
                </tr>
                <tr>
                    <td class="lbl">Delivery Address</td><td class="cl">:</td><td class="val" colspan="4">${this.v(r.address)}</td>
                </tr>
            </table>

            <div class="op-title">Operational Data</div>
            <table class="op">
                <thead>
                    <tr>
                        <th rowspan="2">Chamber No.</th>
                        <th rowspan="2">Quantity</th>
                        <th rowspan="2">Product</th>
                        <th colspan="4">Loading Location</th>
                        <th colspan="4">Receiving Location</th>
                        <th colspan="2">Shortage</th>
                    </tr>
                    <tr>
                        <th>Ref. Dip</th><th>Product Dip</th><th>Temp. (&deg;F)</th><th>Density</th>
                        <th>Ref. Dip</th><th>Product Dip</th><th>Temp.</th><th>Density</th>
                        <th>In MM</th><th>In Ltrs</th>
                    </tr>
                </thead>
                <tbody>
                    ${opRows}
                    <tr class="totalrow">
                        <td class="c"><b>Total</b><br>Ambient Litters</td>
                        <td class="c">${this.v(r.ambiantLiters)}</td>
                        <td colspan="5"></td>
                        <td colspan="2" class="c"><b>Metric Tons</b></td>
                        <td colspan="4" class="c">${this.v(r.metricTons)}</td>
                    </tr>
                </tbody>
            </table>

            <table class="seal">
                <tr>
                    <td class="lbl" rowspan="2">Seal Numbers</td>
                    <td class="hdr">From</td><td class="hdr">To</td><td class="hdr">Total</td>
                </tr>
                <tr><td></td><td></td><td></td></tr>
                <tr>
                    <td class="lbl">Commulative Shortage</td>
                    <td class="hdr2">Amb. Litters</td>
                    <td class="hdr2">Standard Litters</td>
                    <td class="hdr2">Metric Tons</td>
                </tr>
                <tr><td></td><td></td><td></td><td></td></tr>
            </table>

            <table class="net">
                <tr>
                    <td class="lbl" rowspan="2">Net Received</td>
                    <td class="hdr2">Amb. Litters</td><td class="hdr2">Standard Litters</td><td class="hdr2">Metric Tons</td>
                </tr>
                <tr><td></td><td></td><td></td></tr>
            </table>

            <div class="sign">
                <div class="sign-line"></div>
                <div class="sign-label">Authorized Signature</div>
            </div>
        </div>`;
    }

    private styles(): string {
        return `
        <style>
            * { font-family: Arial, Helvetica, sans-serif; box-sizing: border-box; }
            body { margin: 0; color: #000; }
            .dn-slip { width: 100%; padding: 4mm; page-break-after: always; }
            .dn-slip:last-child { page-break-after: auto; }

            .head { display: flex; align-items: center; margin-bottom: 12px; }
            .head-logo { width: 110px; display: flex; align-items: center; justify-content: flex-start; }
            .head-spacer { width: 110px; }
            .head-title { flex: 1; text-align: center; }
            .logo-img { max-height: 60px; max-width: 100px; object-fit: contain; }
            .logo-space { width: 100px; height: 60px; }
            .company { font-size: 22px; font-weight: bold; line-height: 1.1; }
            .subtitle { font-size: 14px; font-weight: bold; margin-top: 2px; }

            table { border-collapse: collapse; width: 100%; }
            .info td { border: 1px solid #000; padding: 3px 6px; font-size: 11px; }
            .info .lbl { font-weight: bold; width: 13%; white-space: nowrap; }
            .info .cl { width: 1%; text-align: center; }
            .info .val { width: 20%; }

            .op-title { font-size: 13px; margin: 10px 0 3px; }
            .op th, .op td { border: 1px solid #000; font-size: 9px; padding: 3px 2px; text-align: center; vertical-align: middle; }
            .op th { background: #f0f0f0; font-weight: bold; }
            .op td { height: 18px; }
            .op td.c { text-align: center; }

            .seal, .net { margin-top: 10px; }
            .seal td, .net td { border: 1px solid #000; font-size: 10px; padding: 4px 6px; height: 20px; }
            .seal .lbl, .net .lbl { font-weight: bold; text-align: center; width: 22%; }
            .seal .hdr, .net .hdr, .seal .hdr2, .net .hdr2 { text-align: center; font-weight: bold; }

            .sign { margin-top: 45px; }
            .sign-line { width: 220px; border-top: 1px solid #000; margin-bottom: 4px; }
            .sign-label { font-size: 11px; font-weight: bold; }

            @media print {
                @page { size: A4 portrait; margin: 10mm; }
                .dn-slip { padding: 0; }
            }
        </style>`;
    }

    private buildHtml(rows: FuelDispatch[], logoUrl: string, companyName: string, autoPrint: boolean): string {
        const slips = rows.map((r) => this.slipHtml(r, logoUrl, companyName)).join('');
        const script = autoPrint ? `<script>window.onload=function(){ setTimeout(function(){ window.print(); }, 300); }</script>` : '';
        return `<html><head><title>Delivery Advice Note</title>${this.styles()}</head>
            <body>${slips}${script}</body></html>`;
    }

    // PRINT (browser print dialog -> yahan se "Save as PDF" bhi)
    print(rows: FuelDispatch[], logoUrl: string = '', companyName: string = ''): void {
        const html = this.buildHtml(rows, logoUrl, companyName, true);
        const win = window.open('', '_blank', 'width=900,height=1000');
        if (win) {
            win.document.open();
            win.document.write(html);
            win.document.close();
        }
    }

    // "Download PDF" bhi ab native print se -> user print dialog mein "Save as PDF" chunega
    async downloadPdf(rows: FuelDispatch[], logoUrl: string = '', companyName: string = ''): Promise<void> {
        // native print = sabse saaf output, logo + borders sahi
        this.print(rows, logoUrl, companyName);
    }
}
